import { Icon } from "@iconify/react";
import fileTextFill from "@iconify/icons-eva/file-text-fill";
import alertTriangleFill from "@iconify/icons-eva/alert-triangle-fill";
import {
  DnDashboardIcons,
  DnAffirmationIcons,
  DnGoalStatmentIcons,
  DnGratitudeIcons,
  DnMemoriesIcons,
  DnFaqIcons,
  DnVideos,
  DnPodsIcons,
  DnProgrammeIcons,
  DnQuotesIcons,
  DnVaultIcons,
} from "src/assets";
import { project_name } from "../../config/config";
// ----------------------------------------------------------------------
let dashboard_icon = "";
let goal_statement_icon = "";
let programmes_icon = "";
let vault_icon = "";
let pods_icon = "";
let affirmations_icon = "";
let gratitude_icon = "";
let quotes_icon = "";
let memories_icon = "";
let video_icon = "";
let calender_icon = "";
let support_ticket_icon = "";
let faq_icon = "";
if (project_name === "DANIELLE") {
  dashboard_icon = DnDashboardIcons;
  goal_statement_icon = DnGoalStatmentIcons;
  programmes_icon = DnProgrammeIcons;
  vault_icon = DnVaultIcons;
  pods_icon = DnPodsIcons;
  affirmations_icon = DnAffirmationIcons;
  gratitude_icon = DnGratitudeIcons;
  quotes_icon = DnQuotesIcons;
  memories_icon = DnMemoriesIcons;
  video_icon = DnVideos;
  calender_icon = DnMemoriesIcons;
  support_ticket_icon = DnMemoriesIcons;
  faq_icon = DnFaqIcons;
} else {
  dashboard_icon = fileTextFill;
  goal_statement_icon = fileTextFill;
  programmes_icon = fileTextFill;
  vault_icon = fileTextFill;
  pods_icon = fileTextFill;
  affirmations_icon = fileTextFill;
  gratitude_icon = fileTextFill;
  quotes_icon = fileTextFill;
  memories_icon = fileTextFill;
  calender_icon = fileTextFill;
  support_ticket_icon = alertTriangleFill;
  faq_icon = alertTriangleFill;
}

const getIcon = (name) => {
  if (project_name === "DANIELLE") {
    return <img src={name} width={22} height={22} />;
  } else {
    return <Icon icon={name} width={22} height={22} />;
  }
};

const sidebarConfig = (navbarList, consultantInfo, userInfo) => {
  let sidebarMenus = [];
  sidebarMenus.push({
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon(dashboard_icon),
    matches: ["/dashboard", "/post-detail", "/video-detail"],
  });
  if (navbarList && navbarList.programmes) {
    sidebarMenus.push({
      title: "Programs",
      path: "/programs",
      icon: getIcon(programmes_icon),
      matches: [
        "/programs",
        "/lessons",
        "/recordings",
        "/lessons-recordings",
        "/study-session",
      ],
    });
  }
  if (navbarList && navbarList.calendar) {
    sidebarMenus.push({
      title: "calendar",
      path: "/calendar",
      icon: getIcon(calender_icon),
    });
  }
  if (navbarList && navbarList.pods) {
    sidebarMenus.push({
      title: "Community Rooms",
      path: "/community-rooms",
      icon: getIcon(pods_icon),
    });
  }
  if (navbarList && navbarList.the_vault) {
    sidebarMenus.push({
      title: "Replay Library",
      path: "/replay-library",
      icon: getIcon(vault_icon),
    });
  }
  if (
    userInfo &&
    userInfo.goal_statement_status &&
    navbarList &&
    navbarList.goal_statement
  ) {
    sidebarMenus.push({
      title: "goal statement",
      path: "/goal-statement",
      icon: getIcon(goal_statement_icon),
    });
  }
  if (navbarList && navbarList.self_image) {
    sidebarMenus.push({
      title: "self image",
      path: "/self-image",
      icon: getIcon(goal_statement_icon),
    });
  }
  if (navbarList && navbarList.journal_prompt) {
    sidebarMenus.push({
      title: "journal prompts",
      path: "/journal-prompt",
      icon: getIcon(goal_statement_icon),
    });
  }
  if (navbarList && navbarList.portals) {
    sidebarMenus.push({
      title: "Danielle's Events / Portals",
      path: "/portals",
      icon: getIcon(vault_icon),
    });
  }
  if (navbarList && navbarList.gratitude) {
    sidebarMenus.push({
      title: "gratitude",
      path: "/gratitude",
      icon: getIcon(gratitude_icon),
    });
  }
  if (navbarList && navbarList.affirmations) {
    sidebarMenus.push({
      title: "affirmations",
      path: "/affirmations",
      icon: getIcon(affirmations_icon),
    });
  }

  if (navbarList && navbarList.quotes) {
    sidebarMenus.push({
      title: "quotes",
      path: "/quotes",
      icon: getIcon(quotes_icon),
    });
  }
  if (navbarList && navbarList.memories) {
    sidebarMenus.push({
      title: "memories",
      path: "/memories",
      icon: getIcon(memories_icon),
    });
  }

  if (navbarList && navbarList.faq) {
    sidebarMenus.push({
      title: "FAQs",
      path: "/faqs",
      icon: getIcon(faq_icon),
    });
  }
  if (navbarList && navbarList.community_feeds) {
    sidebarMenus.push({
      title: "Community News Feed",
      path: "/community-news-feed",
      icon: getIcon(pods_icon),
    });
  }
  if (navbarList && navbarList.support_ticket) {
    sidebarMenus.push({
      title: "support ticket",
      path: "/support-ticket",
      icon: getIcon(support_ticket_icon),
    });
  }
  if (navbarList && navbarList.consultant_recordings) {
    consultantInfo !== null &&
      consultantInfo !== undefined &&
      consultantInfo !== "undefined" &&
      consultantInfo.status === true &&
      consultantInfo.team_type !== "team" &&
      sidebarMenus.push({
        title:
          consultantInfo.first_name +
          " " +
          consultantInfo.last_name +
          "'s Recording",
        path: "/consultant-recordings",
        icon: getIcon(vault_icon),
      });
  }

  if (navbarList && navbarList.helping_videos) {
    sidebarMenus.push({
      title: "Helping videos",
      path: "/helping-videos",
      icon: getIcon(video_icon),
    });
  }

  if (navbarList && navbarList.affiliate_links) {
    sidebarMenus.push({
      title: "Affiliate Links",
      path: "/affliate-links",
      icon: getIcon(programmes_icon),
    });
  }
  if (navbarList && navbarList.commission_details) {
    sidebarMenus.push({
      title: "Commission Detail",
      path: "/commission-detail",
      icon: getIcon(programmes_icon),
    });
  }

  return sidebarMenus;
};
export default sidebarConfig;
